module.exports = __webpack_public_path__ + "img/5.9fc1df88.svg";